import { apiMessage } from './api'
import { RpcService } from '@/services'

const namespaced = true

const actions = {
  sendSingleMessage (_context, { text, userId }) {
    return new Promise((resolve, reject) => {
      RpcService.encodeRpcSendMessageClientRequest(text)
        .then((body) => {
          apiMessage.sendSingleMessage({ userId, body })
            .then(resolve)
        }).catch((error) => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced,
  actions
}
